<template>
  <div>
    <div class=" row mb-2">
      <label class="col-sm-4  text-lr lh40">
        <el-tooltip class="item" effect="dark" content="新建计划设定后执行类型不可更改" placement="top-start"
                    v-if=" Data.data.c_id==='4501300001'">
          <i class="el-icon-warning"></i>
        </el-tooltip>
        <i v-if=" Data.data.c_priority==='S'"
           class="fa fa-asterisk text-danger font10 ml-1"
           aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 ">
        <div v-if="Data.data.c_choice.type!=='api'">
          <el-select v-model='value' placeholder="请选择" @change="get_data(Data,value)"
                     value-key="id" clearable @focus="get_select_data(Data.data)">
            <el-option v-for="v in options" :key="v.id" :label="v.value" :value="v.value"
                       :disabled="v.disabled"></el-option>
          </el-select>
          {{ Data.data.c_unit }}
        </div>
        <div v-if="Data.data.c_choice.type==='api'">
          <el-dropdown trigger="click" ref="Dropdown" hide-on-click>
            <el-input v-model="value" placeholder="请选择要配置的内容" @focus="get_select_data(Data.data)" clearable
                      @clear="$get_function(Data,null)">
            </el-input>
            <el-dropdown-menu slot="dropdown" style="width: 230px;max-height: 300px;overflow-y: scroll">
              <el-tree :data="options" :props="defaultProps" ref="tree" class="filter-tree" accordion
                       @node-click="get_tree_data($event,Data)">
              </el-tree>
            </el-dropdown-menu>
          </el-dropdown>
          {{ Data.data.c_unit }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "radio",
  props: [
    'Data',
  ],
  data() {
    return {
      formLabelWidth: '200px',
      options: [], // 模拟传过来的数组
      value: this.Data.data.c_value,
      defaultProps: {
        children: 'children',
        label: 'label',

      },
      manufactData: [],//厂商数据
      attr_list: [],
    }
  },
  created() {
    console.log(this.Data,'7yeew')

  },
  methods: {
    //获取树结构选择数据
    get_tree_data(e, Data) {
      if (this.Data.attr.type !== 1) {
        this.value = e.label
        this.$get_function(Data, this.value)
        if (this.Data.attr.type === 'enery') {//新增能耗模型
          // this.$emit('enery_data',e)
          this.attr_list = this.$store.state.new_energy_attr_list
          this.attr_list.static_attribute[5].c_value = e.func
          this.attr_list.static_attribute[4].c_value = e.unit
          this.$store.commit('set_new_energy_attr_list', this.attr_list)
          console.log(this.$store.state.new_energy_attr_list, 's')
        }
        //提交厂商数据
        // let url = this.Data.data.c_choice.map
        // this.$axios.post(this.IBMS_API + url).then((response) => {
        //   this.manufactData = response.data.content
        //   // this.tabsData = this.r_obj(response.data.content)
        //   for (let i in this.manufactData) {
        //     if (e.value === this.manufactData[i].id && Data.data.c_code === '402001') {//供应购买
        //       this.$store.commit('get_equipSupData', this.manufactData[i].infoList)
        //       for (let x in this.manufactData[i].infoList) {
        //         this.$get_function({
        //               'obj': 'newEquip', attr: {'type': '2', 'oneIndex': '2', 'twoIndex': '1'},
        //               'data': {'c_code': this.manufactData[i].infoList[x].id}
        //             },
        //             this.manufactData[i].infoList[x].value)
        //       }
        //     } else if (e.value === this.manufactData[i].id && Data.data.c_code === '401003') {//生产厂商
        //       this.$store.commit('get_equipManfData', this.manufactData[i].infoList)
        //       for (let x in this.manufactData[i].infoList) {
        //         this.$get_function({
        //               'obj': 'newEquip', attr: {'type': '2', 'oneIndex': '2', 'twoIndex': '0'},
        //               'data': {'c_code': this.manufactData[i].infoList[x].id}
        //             },
        //             this.manufactData[i].infoList[x].value)
        //       }
        //     } else if (e.value === this.manufactData[i].id && Data.data.c_code === '403007') {//安装商
        //       this.$store.commit('get_equipInstData', this.manufactData[i].infoList)
        //       for (let x in this.manufactData[i].infoList) {
        //         this.$get_function({
        //               'obj': 'newEquip', attr: {'type': '2', 'oneIndex': '2', 'twoIndex': '2'},
        //               'data': {'c_code': this.manufactData[i].infoList[x].id}
        //             },
        //             this.manufactData[i].infoList[x].value)
        //       }
        //     } else if (e.value === this.manufactData[i].id && Data.data.c_code === '404005') {//质保单位
        //       this.$store.commit('get_equipWarData', this.manufactData[i].infoList)
        //       for (let x in this.manufactData[i].infoList) {
        //         this.$get_function({
        //               'obj': 'newEquip', attr: {'type': '2', 'oneIndex': '2', 'twoIndex': '3'},
        //               'data': {'c_code': this.manufactData[i].infoList[x].id}
        //             },
        //             this.manufactData[i].infoList[x].value)
        //       }
        //     } else if (e.value === this.manufactData[i].id && Data.data.c_code === '407001') {//维修商
        //       this.$store.commit('get_equipMainData', this.manufactData[i].infoList)
        //       for (let x in this.manufactData[i].infoList) {
        //         this.$get_function({
        //               'obj': 'newEquip', attr: {'type': '2', 'oneIndex': '2', 'twoIndex': '6'},
        //               'data': {'c_code': this.manufactData[i].infoList[x].id}
        //             },
        //             this.manufactData[i].infoList[x].value)
        //       }
        //     } else if (e.value === this.manufactData[i].id && Data.data.c_code === '405001') {//保险
        //       this.$store.commit('get_equipInsuData', this.manufactData[i].infoList)
        //       for (let x in this.manufactData[i].infoList) {
        //         this.$get_function({
        //               'obj': 'newEquip', attr: {'type': '2', 'oneIndex': '2', 'twoIndex': '4'},
        //               'data': {'c_code': this.manufactData[i].infoList[x].id}
        //             },
        //             this.manufactData[i].infoList[x].value)
        //       }
        //     }
        //   }
        // })
      } else {
        let value = e.id
        this.$get_function(Data, value)
      }

    },
    //获取选择数据
    get_data(Data, value) {
      if (this.Data.attr.type !== 1) {
        this.$get_function(Data, value)
      } else {
        let x = this.options.find(item => item.value === value)
        this.$get_function(Data, x.id)
        // this.$get_function({'obj':'','data':{'c_id':'111'}}, x.id)
      }
      if (this.Data.attr.func !== undefined) {
        this.$emit(this.Data.attr.func, this.value)
      }
    },
    // 选择器获取焦点时
    get_select_data(obj) {
      this.options = []
      if (obj.c_choice.type === 'str') {
        var flag = false
        for (let key in obj.c_choice.map) {//设定报警的禁用
          if ((obj.c_choice.map[key] === '能源管理' || obj.c_choice.map[key] === '其他系统' || obj.c_choice.map[key] === '审批'
              || obj.c_choice.map[key] === '定额' || obj.c_choice.map[key] === '循环频率'
              || obj.c_choice.map[key] === '其他') && (obj.c_id === '4501200001' || obj.c_id === '4501200005')) {
            flag = true
          } else {
            flag = false
          }
          this.options.push({'id': key, 'value': obj.c_choice.map[key], disabled: flag})
        }
      } else if (obj.c_choice.type === 'tab') {
        this.$axios.get('/dictionary/' + obj.c_choice.map).then((response) => {
          // this.options = this.r_obj(response.data)
          for (let key in response.data) {
            this.options.push({'id': response.data[key].id, 'value': response.data[key].name})
          }
        })
      } else if (obj.c_choice.type === 'api') {
        this.$axios.post(this.IBMS_API + obj.c_choice.map).then((response) => {
          this.options = this.r_obj(response.data.content)
        })
      }
    },
    //递归函数
    r_obj(data) {
      let temp = []
      for (let i in data) {
        let label = data[i].name
        let id = data[i].id
        let func = ''
        let unit = ''
        if (data[i].func !== undefined) {
          func = data[i].func
          unit = data[i].unit

        }
        let sonList = []
        if (data[i].sonList && data[i].sonList.length !== 0) {
          sonList = this.r_obj(data[i].sonList)
        } else {
          sonList = undefined
        }
        temp.push({'label': label, 'value': id, 'func': func, 'unit': unit, 'children': sonList})
      }
      return temp
    }
  }
}
</script>

<style scoped>

</style>
